var _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCheckbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .border {\n        stroke: #e5e8eb;\n        fill: none;\n      }\n      .bg {\n        fill: none;\n      }\n      .content {\n        fill: #e5e8eb;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 71596",
    className: "border",
    d: "M3.2 0h9.6A3.2 3.2 0 0 1 16 3.2v9.6a3.2 3.2 0 0 1-3.2 3.2H3.2A3.2 3.2 0 0 1 0 12.8V3.2A3.2 3.2 0 0 1 3.2 0z",
    transform: "translate(.5 .5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 10930",
    className: "bg",
    d: "M0 0h15v15H0z",
    transform: "translate(.5 1.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 70994",
    className: "content",
    d: "M6327.495 12292.9a1 1 0 0 1-.707-.293l-3-3a1 1 0 0 1 1.414-1.414l2.294 2.294 4.075-4.074a1 1 0 0 1 1.414 1.414l-4.782 4.781a1 1 0 0 1-.708.292z",
    transform: "translate(-6319.289 -12281.57)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckbox);
export default __webpack_public_path__ + "static/media/ic_checkbox.33c45ba88eae826b37b264b258f4b49c.svg";
export { ForwardRef as ReactComponent };